import React from 'react';

import {Route, Routes, useParams} from "react-router-dom";
import {useLocation, useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import DSPlayerEvents from "../PlayerEvents/ds/PlayerEvents"
///import UserStates from "../UserStates";
import Charger from "../Charger/ds";
import PrefabsDS from "../Prefabs/ds/PrefabsDS";
import WhiteListManagement from "../WhiteListManagement";
import {Box, Button, Divider, MenuList, Stack, Toolbar} from "@mui/material";
import CollapsibleDrawer from "../../components/Common/Layout/CollapsibleDrawer";
import NavMenuItem from "../../components/Common/Layout/NavMenuItem";
import {useMenu} from "../../core/context/menuContext";
import AiTicketsDrawer from "../../components/AiTickets/AiTicketsDrawer";

//import UserStatesDS from "../UserStates/ds";
import ChargeManagement from "../ChargeManagement/ba";
import AllRtChargerLogs from "../ChargerLogs/rt/AllRtChargerLogs";
import AdvancedSearch from "../AdvancedSearch";
import {isEmpty} from "../../core/utils/StringUtils";
import {getDeviceIdAbsentWarning} from "../../core/utils/constants";
import SearchBarRT from "../Search/SearchRT";
import AdvancedSearchRT from "../AdvancedSearch/AdvancedSearchRT";
import {useGetGuidMapDSQuery} from "../../core/api/ds-charge-api";
//import DashboardDS from "../Dashboard/ds";

import AnalyticsDS from "../Analytics/ds";
import ArchiveDS from "../Archive/ds/ArchiveDS";
import AdvancedSearchDS from "../AdvancedSearch/AdvancedSearchDS";
import SearchBarDS from "../Search/SearchDS";
import {ErrorBoundary} from "@sentry/react";
import AllDSChargerLogs from "../ChargerLogs/ds/AllDSChargerLogs";
import UserStatesMC from "../UserStates/mc";
import UserStatesDS from "../UserStates/ds";
import DashboardDS from "../Dashboard/ds";
import ArticleExporter from "../ArticleExporter/ArticleExporter"
import AnalyticalSearchDS from "../AnalyticalSearch/AnalyticalSearchDS"
import {MephistoProfile} from "../Profile/MephistoProfile";
import PersonalData from "../PersonalData";
import AiZendeskSettings from "../AiZendesk";
import SyncConflictsDS from "../SyncConflicts/ds";
import AssistantChat from "../AssistantChat";

export default function MainDS() {
    const {game, action} = useParams();
    const CommonData = useSelector((state) => state.data.CommonData)
    const mode = useSelector((state) => state.data.SourceMode)
    let deviceId = CommonData.deviceId ? CommonData.deviceId : '';
    let vendorId = CommonData.stateId ? CommonData.stateId : '';


    const location = useLocation();
    const dispatch = useDispatch();
    let navigate = useNavigate();

    if (deviceId != '' && deviceId != CommonData.deviceId) {
        dispatch({
            type: "SET_DEVICE_ID",
            payload: {deviceId},
        });
    } else {
        if (typeof CommonData.deviceId == 'string') {
            deviceId = CommonData.deviceId
        }
    }

    // expanded/collapsed by the burger button in the Header
    const {open: menuOpen} = useMenu()

    const main_menu = [
        {
            to: `/${game}/assistant`,
            path: "assistant",
            title: "Assistant",
            element: <AssistantChat />,
            isDividerAfter:true

        },
        {
            to: '/' + game + '/dashboard/' + deviceId + '?vendorId=' +vendorId,
            path: 'dashboard/:deviceId?',
            title: 'Dashboard',
            element: <DashboardDS/>
        },
        {
            to: '/' + game + '/state/' + deviceId + '?vendorId=' +vendorId,
            path: 'state/:deviceId?/:tab?/:subtab?',
            title: 'User State',
            element: <UserStatesDS/>,
            // disabled: deviceId == ''
        },
        {
            to: `/${game}/player-events/${deviceId}`,
            path: "player-events/:deviceId?/:tab?/:subtab?",
            title: "Player Events",
            element: <DSPlayerEvents />
        },

        {
            to: '/' + game + '/analytics/' + deviceId + '?vendorId=' +vendorId,
            path: 'analytics/:deviceId?/:tab?/:subtab?',
            title: 'Analytics',
            element: <AnalyticsDS/>,
            isDividerAfter:true

            // disabled: deviceId == ''
        },
    ];
    const state_menu = [

        {to: '/' + game + '/charger/' + deviceId + '?vendorId=' +vendorId, path: 'charger/:deviceId?', title: 'Charger', element: <Charger/>},

        {to: '/' + game + '/logs', path: 'logs', title: 'ChargerLogs', element: <AllDSChargerLogs/>},
        //{to:'reports', title:'Reports',component:'<Reports />'},

    ]
    const common_menu = [
        {
            to: '/' + game + '/prefabs/' + deviceId + '?vendorId=' +vendorId,
            path: "prefabs/:deviceId?",
            title: 'Prefabs',
            element: <PrefabsDS game={game}/>
        },
        {
            to: '/' + game + '/archive/' + deviceId + '?vendorId=' +vendorId,
            path: "archive/:deviceId?",
            title: 'Archive',
            element: <ArchiveDS game={game}/>,
            isDividerAfter:true

        },
        {
            to: `/${game}/sync-conflicts`,
            path: "sync-conflicts",
            title: "Sync Conflicts",
            element: <SyncConflictsDS game={game} />
        },
        {
            to: '/' + game + '/search',
            path: "search",
            title: 'Search',
            element: <AdvancedSearchDS game={game}/>
        },
        {
            to: `/${game}/analytical-search`,
            path: "analytical-search",
            title: "Analytical Search",
            element: <AnalyticalSearchDS />
        },
        {
            to: `/${game}/profile/`+deviceId,
            path: "profile/:deviceId?",
            title: "Mephisto Profile",
            element: <MephistoProfile />,
            isDividerAfter:true

        }
    ]
    const admin_menu = [
        {
            to: '/' + game + '/chargeManagement',
            path: "chargeManagement",
            title: 'Charge Management',
            element: <ChargeManagement game={game}/>
        },
        {
            to: '/' + game + '/whitelistManagement',
            path: "whitelistManagement",
            title: 'White list management',
            element: <WhiteListManagement/>
        },
        {
            to: `/${game}/article-exporter`,
            path: "article-exporter",
            title: "Article Exporter",
            element: <ArticleExporter project={game} />
        },
        ...(mode.isProd ? [{
            to: `/${game}/personal-data`,
            path: "personal-data",
            title: "GDPR",
            element: <PersonalData initialProject="brilliant-sort" />
        }] : []),
        ...(mode.isProd ? [{
            to: `/${game}/ai-zendesk`,
            path: "ai-zendesk",
            title: "Zendesk",
            element: <AiZendeskSettings game={game} />
        }] : [])
    ]

    // first path segment ("dashboard/:deviceId?" -> "dashboard") matches the :action route param
    const isActive = (object) => object.path.split("/")[0] === action

    let menu = [
        ...main_menu,
        ...state_menu,
        ...common_menu
    ]

    const deviceIdIsEmpty = (isEmpty(deviceId) || typeof deviceId == 'object') && isEmpty(vendorId);

    const routes = (
        <Route>

            {menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
            {admin_menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
        </Route>
    );


    const ErrorFallback = ({ error, componentStack, resetError }) => (
        <Box sx={{pt:2}}>
            <h2>Error</h2>
            <p>{error.message}</p>
            <Button variant="contained" onClick={resetError} sx={{mb: 2}}>Try again</Button>
            <pre>{componentStack}</pre>
        </Box>
    );

    // Stack, not Box: App.css has a global ".MuiBox-root a" rule that would break the vertical menu
    return (
        <Stack direction="row" sx={{flexGrow: 1, minWidth: 0, width: "100%"}}>
            <CollapsibleDrawer anchor="left" width={230} open={menuOpen} label="menu" hideScrollbar>
                <MenuList>
                    {menu.map((object) => (
                        <React.Fragment key={object.path}>
                            <NavMenuItem {...object} open={menuOpen} selected={isActive(object)}/>
                            {object?.isDividerAfter && <Divider/>}
                        </React.Fragment>
                    ))}

                    {admin_menu.map((object) => (
                        <NavMenuItem key={object.path} {...object} open={menuOpen} selected={isActive(object)}/>
                    ))}
                </MenuList>
            </CollapsibleDrawer>
            <Box component="main"
                 sx={{flexGrow: 1, minWidth: 0, p: 3}}
            >
                <Toolbar/>

                {['chargeManagement', 'whitelistManagement', 'search', "analytical-search", "article-exporter", "sync-conflicts", "personal-data", "assistant", "ai-zendesk"].indexOf(action) == -1 &&
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            mb: 2
                        }}>
                        <SearchBarDS />
                    </Box>
                }

                <ErrorBoundary key={`${game}/${action}`} fallback={ErrorFallback} >

                    <Box sx={{
                        width: "100%",
                        mb: 2
                    }}>
                        {(deviceIdIsEmpty && (action == 'dashboard' || action=='state') ) ? getDeviceIdAbsentWarning() :
                            <Routes>
                                {main_menu.map((object) => (
                                    <Route path={object.path} element={object.element}/>
                                ))}
                            </Routes>
                        }
                        <Routes>
                            {state_menu.map((object) => (
                                <Route path={object.path} element={object.element}/>
                            ))}
                            {common_menu.map((object) => (
                                <Route path={object.path} element={object.element}/>
                            ))}
                            {admin_menu.map((object) => (
                                <Route path={object.path} element={object.element}/>
                            ))}
                        </Routes>

                    </Box>
                </ErrorBoundary>

            </Box>
            <AiTicketsDrawer/>
        </Stack>
    );
}
